function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dispatch"];
function cov_1a099vptke() {
  var path = "/app/src/hooks/use-widget-data.ts";
  var hash = "35299181776a21c86a90361a46e56067656ff3dc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-widget-data.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 36
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 20,
          column: 14
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "3": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 16,
          column: 8
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "5": {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "6": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "7": {
        start: {
          line: 35,
          column: 18
        },
        end: {
          line: 76,
          column: 68
        }
      },
      "8": {
        start: {
          line: 36,
          column: 42
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "10": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 51,
          column: 7
        }
      },
      "11": {
        start: {
          line: 42,
          column: 21
        },
        end: {
          line: 42,
          column: 51
        }
      },
      "12": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 67
        }
      },
      "13": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 15
        }
      },
      "14": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 61
        }
      },
      "15": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 61
        }
      },
      "16": {
        start: {
          line: 54,
          column: 17
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "17": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 75,
          column: 7
        }
      },
      "18": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 80,
          column: 34
        }
      },
      "19": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 14
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 36
          },
          end: {
            line: 10,
            column: 37
          }
        },
        loc: {
          start: {
            line: 10,
            column: 49
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 40
          },
          end: {
            line: 11,
            column: 41
          }
        },
        loc: {
          start: {
            line: 11,
            column: 63
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 23,
            column: 30
          }
        },
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 30
          },
          end: {
            line: 35,
            column: 31
          }
        },
        loc: {
          start: {
            line: 35,
            column: 42
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 78,
            column: 12
          },
          end: {
            line: 78,
            column: 13
          }
        },
        loc: {
          start: {
            line: 78,
            column: 18
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 78
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "35299181776a21c86a90361a46e56067656ff3dc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1a099vptke = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1a099vptke();
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect } from 'react';
import { getWidgetData } from 'src/api/get-widget-data';
import { getEntityId } from 'src/checkout-frame/api/get-entity-id';
import { ACTIONS, MOBILE_BRIDGE_QUERY_PARAM_NAME } from 'src/constants/common';
import { mobileBridge } from 'src/services/mobile-bridge';
import { dataDog } from 'src/utils/datadog/data-dog';
cov_1a099vptke().s[0]++;
var clearPayloadFromEmptyValues = function clearPayloadFromEmptyValues(rest) {
  cov_1a099vptke().f[0]++;
  cov_1a099vptke().s[1]++;
  return Object.entries(rest).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    cov_1a099vptke().f[1]++;
    cov_1a099vptke().s[2]++;
    if (value !== '') {
      cov_1a099vptke().b[0][0]++;
      cov_1a099vptke().s[3]++;
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
    } else {
      cov_1a099vptke().b[0][1]++;
    }
    cov_1a099vptke().s[4]++;
    return acc;
  }, {});
};
cov_1a099vptke().s[5]++;
export var useWidgetData = function useWidgetData(_ref3) {
  var dispatch = _ref3.dispatch,
    rest = _objectWithoutProperties(_ref3, _excluded);
  cov_1a099vptke().f[2]++;
  var _ref4 = (cov_1a099vptke().s[6]++, clearPayloadFromEmptyValues(rest)),
    publicKey = _ref4.publicKey,
    merchantCode = _ref4.merchantCode,
    currency = _ref4.currency,
    amount = _ref4.amount,
    webview = _ref4.webview;
  var getData = (cov_1a099vptke().s[7]++, useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var shouldGetDataFromMobileBridge, _data, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          cov_1a099vptke().f[3]++;
          shouldGetDataFromMobileBridge = (cov_1a099vptke().s[8]++, window.location.search.includes(MOBILE_BRIDGE_QUERY_PARAM_NAME));
          cov_1a099vptke().s[9]++;
          if (!shouldGetDataFromMobileBridge) {
            _context.n = 4;
            break;
          }
          cov_1a099vptke().b[1][0]++;
          cov_1a099vptke().s[10]++;
          _context.p = 1;
          cov_1a099vptke().s[11]++;
          _context.n = 2;
          return mobileBridge.awaitData();
        case 2:
          _data = _context.v;
          cov_1a099vptke().s[12]++;
          dispatch({
            type: ACTIONS.GET_WIDGET_DATA,
            payload: _data
          });
          cov_1a099vptke().s[13]++;
          return _context.a(2);
        case 3:
          _context.p = 3;
          _t = _context.v;
          cov_1a099vptke().s[14]++;
          // eslint-disable-next-line no-console
          console.error('mobileBridge.awaitData error', _t);
          cov_1a099vptke().s[15]++;
          dataDog.error('mobileBridge.awaitData error', _t);
          _context.n = 5;
          break;
        case 4:
          cov_1a099vptke().b[1][1]++;
        case 5:
          cov_1a099vptke().s[16]++;
          _context.n = 6;
          return getWidgetData({
            ab: {
              entityId: getEntityId(),
              entity: 'widgets_customer',
              platform: 'web',
              filters: {
                merchantId: publicKey,
                merchantCode: merchantCode,
                currency: currency
              }
            },
            publicKey: publicKey,
            merchantCode: merchantCode,
            currency: currency,
            amount: amount,
            webview: webview
          });
        case 6:
          data = _context.v;
          cov_1a099vptke().s[17]++;
          dispatch({
            type: ACTIONS.GET_WIDGET_DATA,
            payload: data
          });
        case 7:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  })), [publicKey, merchantCode, currency, amount, dispatch, webview]));
  cov_1a099vptke().s[18]++;
  useEffect(function () {
    cov_1a099vptke().f[4]++;
    cov_1a099vptke().s[19]++;
    getData();
  }, [currency, amount, getData]);
};